import * as React from "react";

import { cn } from "@/lib/utils";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea"> & {
    variant?: "default" | "brand";
    onSubmitPress?: () => void;
  }
>(
  (
    { className, variant = "default", onKeyDown, onSubmitPress, ...props },
    ref,
  ) => {
    const onKeyDownHandler = (ev: React.KeyboardEvent<HTMLTextAreaElement>) => {
      if (ev.key === "Enter" && !ev.shiftKey && onSubmitPress) {
        ev.preventDefault();
        onSubmitPress();
      } else {
        onKeyDown?.(ev);
      }
    };

    return (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          "focus:border-secondary transition-colors duration-200",
          variant === "brand" && "text-[#1f4746]",
          className,
        )}
        ref={ref}
        onKeyDown={onKeyDownHandler}
        {...props}
      />
    );
  },
);
Textarea.displayName = "Textarea";

export { Textarea };
